// removed by extract-text-webpack-plugin
module.exports = {"msignaturepad":"documentLink__msignaturepad___3BQvv","m-signature-pad--body":"documentLink__m-signature-pad--body___1u-b0","m-signature-pad--footer":"documentLink__m-signature-pad--footer___sL_xN","description":"documentLink__description___I1U6H","button":"documentLink__button___D5Nry","clear":"documentLink__clear___mf7Ot","save":"documentLink__save___Izi01","m-signature-pad":"documentLink__m-signature-pad___3hGpX","github":"documentLink__github___tDBzL","notUse":"documentLink__notUse___3w7b0"};


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/components/LineItemTable/documentLink.scss
// module id = ewgj
// module chunks = client